export class AdminSettingsUpdateRequest {
    NewsEmail: string;
    AdvertisementEmail: string;
    DiscountEmail: string;
    ApplicationEmail: string;
    LetterEmail: string;
}